//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import wikiSelect from '~/components/common/wikiSelect.vue'
import pieCharts from '~/components/home/fundsFlowdatails/pieCharts.vue'
import { getToday, getAppointNMonth } from '~/assets/js/utils.js'
export default {
  components: {
    wikiSelect,
    pieCharts
  },
  props: {
    tradeTrend: {
      type: Object, default: () => {}
    },
    swap: {
      type: Object, default: () => {}
    },
    brokerRankForSwap: {
      type: Object, default: () => {}
    }
  },
  data () {
    return {
      updatetime: '', // 更新时间
      selectInd: 1,
      income: 0, // 收入
      blowoutData: [],
      classifyPieData: [], // 按品种分类数据
      pieData: [
        { value: 1048, symbol: '流入' },
        { value: 335, symbol: '流出' }
      ],
      optionList: [
        { value: 1, label: '12764' },
        { value: 2, label: '12765' },
        { value: 3, label: '12766' }
      ]
    }
  },
  computed: {
    ...mapState(['screenWidth', 'locale', 'suffix'])
  },
  created () {
    // 数据更新时间
    this.updatetime = this.tradeTrend.updatetime

    const { swap_distribution: swapDistribution = [], totalSwapIn = 0, totalSwapOut = 0 } = this.swap
    // 30天隔夜收入
    this.pieData[0].value = parseInt(Math.abs(totalSwapIn))
    this.pieData[1].value = parseInt(Math.abs(totalSwapOut))
    this.income = parseInt(totalSwapIn - totalSwapOut)
    // 按品种分类
    swapDistribution?.forEach((item, index) => {
      if (index < 5) this.classifyPieData.push({ value: parseInt(item.swap - 0), symbol: item.symbol, rate: item.rate })
    })

    // 隔夜费收入排行
    const { brokerRankForSwap: list = [] } = this.brokerRankForSwap
    let totol = 0
    list?.sort((a, b) => { return b.swapin - a.swapin })
    list?.forEach((item, index) => {
      if (index < 7) {
        totol += (item.swapin - 0)
        this.blowoutData.push({ id: item.Brokers, img: item.brokerIcon, name: item.brokerName, value: '0', num: item.swapin })
      }
    })
    this.blowoutData.unshift({ id: '0', img: 'https://resources.interface003.com/cloud/img/home/night-all.svg', name: this.$t('TYY_000110'), value: '100', num: totol })
    this.blowoutData.forEach((item, index) => {
      if (index != 0) item.value = (item.num / totol * 100).toFixed(2)
    })
  },
  methods: {
    // 获取折线图数据
    getLineData (type = 'speed', symbol = 'EURUSD ') {
      try {
        this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/tradeTrend' }, { languageCode: this.currLangCode(), type, symbol }).then(({ updatetime = '' }) => {
          this.updatetime = updatetime
        })
      } catch {}
    },
    open (id) {
      if (id != 0) window.open(`https://www.wikifx.${this.suffix}/${this.currLangCode()}/dealer/${id}.html`)
    },
    changeOption (e) { // 切换周期
      this.selectInd = e.value
      if (e.value == 1) {
        this.getChartsData(getAppointNMonth('', 1), getToday())
        this.getListData(2)
      } else if (e.value == 2) {
        this.getChartsData(getAppointNMonth('', 3), getToday())
        this.getListData(3)
      } else if (e.value == 3) {
        this.getChartsData(getAppointNMonth('', 6), getToday())
        this.getListData(4)
      }
    },
    async getChartsData (startTime = getAppointNMonth('', 1), endTime = getToday()) { // 获取左侧数据
      try {
        const arr = []
        const { swap_distribution: swapDistribution = [], totalSwapIn = 0, totalSwapOut = 0 } = await this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/swap' }, { startTime, endTime })
        this.pieData[0].value = parseInt(Math.abs(totalSwapIn))
        this.pieData[1].value = parseInt(Math.abs(totalSwapOut))
        this.income = parseInt(totalSwapIn - totalSwapOut)
        swapDistribution?.forEach((item, index) => {
          if (index < 5) arr.push({ value: parseInt(item.swap - 0), symbol: item.symbol, rate: item.rate })
        })
        this.classifyPieData = arr
      } catch {}
    },
    async getListData (period = 2) { // 获取隔夜费收入排行数据
      const { brokerRankForSwap: list = [] } = await this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/brokerRankForSwap' }, { period })
      let totol = 0
      const arr = []
      list.sort((a, b) => {
        return b.swapin - a.swapin
      })
      list?.forEach((item, index) => {
        if (index < 7) {
          totol += (item.swapin - 0)
          arr.push({ id: item.Brokers, img: item.brokerIcon, name: item.brokerName, value: '0', num: item.swapin })
        }
      })
      arr.unshift({ id: '0', img: 'https://resources.interface003.com/cloud/img/home/night-all.svg', name: this.$t('TYY_000110'), value: '100', num: totol })
      arr.forEach((item, index) => {
        if (index != 0) {
          item.value = (item.num / totol * 100).toFixed(2)
        }
      })
      this.blowoutData = arr
    }
  }
}
